import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { transformMoratoriosData } from './dataTransforms';
import { formatCurrency } from '../../../utils/formatCurrency';
import { CHART_COLORS } from './chartColors';

function CustomTooltip({ active, payload }) {
  if (!active || !payload || !payload.length) return null;
  const { nombreCompleto, monto, mensualidades } = payload[0].payload;
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #ccc',
        borderRadius: 4,
        padding: '8px 12px',
      }}
    >
      <p style={{ margin: 0, fontWeight: 'bold' }}>{nombreCompleto}</p>
      <p style={{ margin: 0 }}>Monto: {formatCurrency(monto)}</p>
      <p style={{ margin: 0 }}>Mensualidades vencidas: {mensualidades}</p>
    </div>
  );
}

export default function HorizontalBarChart({ data }) {
  const chartData = transformMoratoriosData(data);

  if (!chartData || chartData.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 400,
          color: '#999',
        }}
      >
        Sin datos de clientes moratorios
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart layout="vertical" data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" tickFormatter={(value) => formatCurrency(value)} />
        <YAxis type="category" dataKey="nombre" width={120} />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="monto" fill={CHART_COLORS.MORATORIO} />
      </BarChart>
    </ResponsiveContainer>
  );
}
